<template>
	<div class="content-wrapper">
		<pageheader title="Images"></pageheader>
		<div class="content">
            <div v-if="isLoaded" class="row">
                <div class="col-md-12">
                    <ui :stats="stats"/>
                </div>
            </div>
            <div v-else>
                <div style="height: 100px">
                    <div class="loader loader-inline no-margin-top"></div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import pageheader from '@components/pages/elements/header'
import uiComponent from '@components/pages/dashboard'

export default {
	name: 'Dashboard',
	components : {
		pageheader,
        'ui' : uiComponent.view
	},
	data() {
		return {
            stats : [],
            isLoaded : false
		}
	},
	mounted () {
        this.initialize();
    },
	computed : {
        data(){
            return {
            }
        }
	},
	methods : {
        initialize() {
            this.loadConfig();
        },
        loadConfig : function(){
            this.$store.dispatch('dashboard/get', {})
            .then((response) => {
                this.stats = response.data;
                this.isLoaded = true;
            })
            .catch( error => {
            });
        }
    }
}
</script>